<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand :to="{ name: 'front' }">
        🌴 UkeAbility
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :to="{ name: 'playalongs', params: { tuning: tuning } }">
            Play-alongs
          </b-nav-item>
          <b-nav-item :to="{ name: 'tutorials', params: { tuning: tuning } }">
            Tutorials
          </b-nav-item>
          <b-nav-item :to="{ name: 'search', params: { tuning: tuning } }">
            Search
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{ name: 'chords', params: { tuning: tuning } }">
            My Chords <b-badge>{{ $store.getters.knownChords.length }}</b-badge>
          </b-nav-item>
          <b-nav-item :to="{ name: 'favorites', params: { tuning: tuning } }">
            My Favorites
          </b-nav-item>

          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <b-badge
                v-if="$store.getters.ukeTuning == 'G'"
                size="sm"
                class="my-2 my-sm-0"
                variant="info"
              >
                Baritone
              </b-badge>
              <span v-if="$store.getters.ukeTuning == 'C'" variant="secondary">
                Tuning
              </span>
            </template>
            <b-dropdown-item
              :active="$store.getters.ukeTuning == 'C'"
              @click="gotoChords('C')"
            >
              C - Standard
            </b-dropdown-item>
            <b-dropdown-item
              :active="$store.getters.ukeTuning == 'G'"
              @click="gotoChords('G')"
            >
              G - Baritone
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item :to="{ name: 'public-submit' }">
            Submit a link
          </b-nav-item>

          <b-nav-item :to="{ name: 'about' }">
            FAQ
          </b-nav-item>

          <b-nav-item v-if="$store.state.authorized" @click="logout">
            Logout
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-container class="main-view">
      <Login v-if="!loginCheck()" />
      <router-view
        v-if="$store.state.chordDataLoaded && loginCheck()"
        class="mt-4"
      />
      <b-toast id="my-toast" variant="success" solid>
        <template v-slot:toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">
              🎉
              {{ $store.getters.knownChords.length.toLocaleString() }} chords!
            </strong>
          </div>
        </template>
        You know the chords for
        <strong>
          {{ $store.getters.knownChordSongCount.toLocaleString() }}
          🎵 songs!
        </strong>
      </b-toast>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Login from "@/components/Login";
export default {
  name: "App",
  components: {
    Footer,
    Login
  },
  data() {
    return {
      knownChordsCount: 0,
      currentTuning: "C"
    };
  },
  computed: {
    knownChords() {
      return this.$store.getters.knownChords;
    },
    tuning() {
      return this.$store.getters.ukeTuning;
    }
  },
  watch: {
    knownChords(value, old_value) {
      if (!value) {
        return;
      }
      console.log(value, old_value, this.currentTuning);
      if (this.currentTuning != this.$store.getters.ukeTuning) {
        this.currentTuning = this.$store.getters.ukeTuning;
        // Do not toast when changing tuning.
        return;
      }
      if (this.knownChordsCount != 0 && this.knownChordsCount < value.length) {
        this.$bvToast.show("my-toast");
      }
      this.knownChordsCount = value.length;
    }
  },
  mounted() {
    console.time("chord from Django");
    console.time("chord from storage");
    this.$store.dispatch("loadInitialUserData");
    this.currentTuning = this.$store.getters.ukeTuning;
    //this.$store.watch(
    //  getters => getters.knownChords,
    //  known_chords => {
    //    console.log(known_chords.length);
    //    this.$bvToast.show("my-toast");
    //  }
    //);
  },
  methods: {
    loginCheck() {
      if (this.$route.meta.login_required && !this.$store.state.authorized) {
        return false;
      }
      return true;
    },
    logout() {
      this.$store.dispatch("logout");
    },
    gotoChords(chord) {
      var route = this.$route;
      var _v = this;
      this.$store.dispatch("setTuning", chord).then(function() {
        if (route.path == "/") {
          _v.$router.push({ name: "playalongs", params: { tuning: chord } });
        } else {
          _v.$router.push({ name: route.name, params: { tuning: chord } });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.main-view {
  min-height: 500px;
}
</style>
